export default __webpack_public_path__ + "static/media/meanio.4424617d.svg";